import dayjs from "dayjs";

export const sortStrings = (a:string, b:string, sort:'asc'|'desc' = 'asc') => {
  return a.localeCompare(b, undefined, { sensitivity: 'base' }) * ( sort === 'asc' ? 1 : -1 );
}

export const sortByCreationDate = (a:any, b:any, sort:'asc'|'desc' = 'desc') => {
  const aTime = new Date(a.createdOn).getTime();
  const bTime = new Date(b.createdOn).getTime();
  return sort === 'desc' ? bTime - aTime : aTime - bTime;
}

export const sortByDate = (a:string|undefined, b:string|undefined, sort:'asc'|'desc' = 'desc') => {
  const aTime = a ? new Date(a).getTime() : 0;
  const bTime = b ? new Date(b).getTime() : 0;

  if (!aTime && !bTime) return 0;
  if (!aTime) return 1;
  if (!bTime) return -1;

  return sort === 'desc' ? bTime - aTime : aTime - bTime;
}

export const sortByName = <T>(a:T, b:T, field:keyof T, sort:'asc'|'desc' = 'asc') => {
  const aName = (a[field] as string).trim().toLowerCase();
  const bName = (b[field] as string).trim().toLowerCase();
  return aName === bName
    ? 0
    : sort === 'asc'
      ? aName < bName ? -1 : 1
      : aName < bName ? 1 : -1
  ;
}

export const sortByNumber = <T>(a: T, b: T, field: keyof T, sort: 'asc' | 'desc' = 'asc') => {
  const aNum = Number(a[field]);
  const bNum = Number(b[field]);

  if (aNum === bNum) return 0;

  return sort === 'asc'
    ? aNum - bNum
    : bNum - aNum;
};

export const sortByPath = <T>(a:T, b:T, path:string, sort:'asc'|'desc' = 'asc') => {
  const getValue = (obj: any, path: string): any => {
    return path.split('.').reduce((val, key) => val?.[key], obj);
  };

  const aVal = getValue(a, path);
  const bVal = getValue(b, path);

  const aExists = typeof aVal === 'string' && aVal.trim() !== '';
  const bExists = typeof bVal === 'string' && bVal.trim() !== '';

  if (!aExists && !bExists) return 0;
  if (!aExists) return 1;
  if (!bExists) return -1;

  const aStr = aVal.trim().toLowerCase();
  const bStr = bVal.trim().toLowerCase();

  if (aStr === bStr) return 0;
  return sort === 'asc' ? (aStr < bStr ? -1 : 1) : (aStr < bStr ? 1 : -1);
};

export const sortCalendarDataByTime = (a:any, b:any) => {
  if (!a.time) return -1;
  if (!b.time) return 1;
  
  const [ aHour, aMinutes] = a.time.split(':').map(Number);
  const [ bHour, bMinutes] = b.time.split(':').map(Number);
  const aTime = dayjs().hour(aHour).minute(aMinutes);
  const bTime = dayjs().hour(bHour).minute(bMinutes);
  return aTime.isBefore(bTime) ? -1 : 1;
}

export const sortByDateTime = (a: any, b: any, type: 'asc' | 'desc' = 'asc') => {
  const getDateTime = (item: any) => {
    if (!item.date) return null;
    return dayjs(`${item.date} ${item.time || '00:00'}`);
  };

  const dateA = getDateTime(a);
  const dateB = getDateTime(b);

  if (!dateA && !dateB) return 0;
  if (!dateA) return type === 'asc' ? -1 : 1;
  if (!dateB) return type === 'asc' ? 1 : -1;

  if (dateA.isBefore(dateB)) return type === 'asc' ? -1 : 1;
  if (dateA.isAfter(dateB)) return type === 'asc' ? 1 : -1;
  return 0;
};
